export default class RequestWorker {
    constructor(modulePrefix, modules, cfTurnstileSitekey) {
        this.modulePrefix = modulePrefix;
        this.modules = modules;
        this.pathPrefix = '/api/v1/';
        this.cfTurnstileSitekey = cfTurnstileSitekey;
    }

    static async init() {
        let url = 'upnav_config.json';
        let data = null;

        try {
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP Error. Status: ${response.status}`);
            }

            data = await response.json();

        } catch (error) {
            console.error("API Request Failed:", error);
            throw error;
        }
        
        const selectedModule = "GL";
        let modules = {};
        let apiProtocol = data.config.apiProtocol;
        let apiDomain = data.config.apiDomain;
        let apiPort = data.config.apiPort;
        let cfTurnstileSitekey = data.config.cfTurnstileSitekey;

        // ─── Cloudflare Turnstile ────────────────────────────────────────────────────────────────\
        //const TURNSTILE_SITE_KEY = "1x00000000000000000000AA"; //always pass
        //const TURNSTILE_SITE_KEY = "2x00000000000000000000AB"; //always fail
        //const TURNSTILE_SITE_KEY = "3x00000000000000000000FF"; //interactive challenge
        //const TURNSTILE_SITE_KEY = "0x4AAAAAADpNonZybrwWgiNp"; //UPCR

        for (const value of Object.values(data.config.modules)) {
            modules[value.prefix] = {
                "name": value.name,
                "url": apiProtocol + "://" + value.apiSubdomain + "." + apiDomain + ":" + apiPort,
                "apikey": !!value.apikey ? value.apikey : ""
            }
        }
        return new RequestWorker(selectedModule, modules, cfTurnstileSitekey);
    }

    getModulePrefix() {
        return this.modulePrefix;
    }
    setModulePrefix(modulePrefix) {
        if(modulePrefix in this.modules){
            this.modulePrefix = modulePrefix;
        }
    }
    getModule() {
        return this.modules[this.modulePrefix];
    }
    getPathPrefix() {
        return this.pathPrefix;
    }
    getCfTurnstileSitekey() {
        return this.cfTurnstileSitekey;
    }

    async apiRequest(endpoint, method = 'GET', body = {}, params = {}, headers = {}, apiKey = null, ddlAgent = {'letter_id': null, 'cash_amount': null, 'last_name': null}, cf_turnstile = null) {
        const module = this.getModule();
        let url = module.url + this.getPathPrefix() + endpoint + "/";
        const options = {
            method: method.toUpperCase(),
            headers: {'Content-Type': 'application/json'}
        };

        if (!!apiKey) {
            options.headers.authorization = "apikey " + apiKey;
        }

        else if (!!module.apikey) {
            options.headers.authorization = "apikey " + module.apikey;
        }

        if (!!ddlAgent && !!ddlAgent['letter_id'] && !!ddlAgent['cash_amount'] && !!ddlAgent['last_name']) {
            options.headers['ddl-key'] = Object.values(ddlAgent).join('|');
            if(!!cf_turnstile){
                options.headers['cf-turnstile'] = cf_turnstile;
            }
        }

        if(!!body) {
            options.body = body
            if (body instanceof FormData) {
                delete options.headers['Content-Type'];
                options.headers['Accept'] = 'application/json, text/plain, */*';
            }
        }

        if(!!params) {
            const queryString = new URLSearchParams(params).toString();
            url += `?${queryString}`;
        }

        //override the default header
        if (!!headers) {
            options.headers = headers;
        }

        try {
            const response = await fetch(url, options);
            const error = new Error(`HTTP Error. Status: ${response.status}`);

            if (response.status === 204) return { success: true };
            else if (response.status >= 500) throw error;

            const data = await response.json()

            if (!response.ok) {
                error.status = response.status;
                error.data = data;
                throw error
            }
            
            return data;

        } catch (error) {
            console.error("API Request Failed:", error);
            throw error;
        }

    }
}
/*
Code examples

    const ddlAgent = {
    'letter_id': "GL4-241",
    'cash_amount': "31.91",
    'last_name': "diaz"
    }
    const params = { 'letter_id': "GL4-241", 'verbosity': 'mobile_app' };

    
    Showing how to use the properties endpoint, which uses the GET method
    ---------------------------------------------------------------------------------------------------
    const response = requestWorker.apiRequest("properties", "GET", null, params, null, null, ddlAgent);
    console.log(response);

    Showing how to use update-ddlresponse endpoint, which uses te PUT method/
    ---------------------------------------------------------------------------------------------------
    const formData = new FormData(); // Form Data is needed to this endpoint

    formData.append('letter_id', 'GL4-241');
    formData.append('ddl_response', 'Holder Removed');
    formData.append('ddl_response_date', '2026-12-13');
    formData.append('ddl_notes', "Hello world!!!!");
    //formData.append('files', blob, "test.jpeg");

    const response = requestWorker.apiRequest("update-ddlresponse", "PUT", formData, null, null, null, ddlAgent);

    //Make sure to wrap this apiRequest function in try catch like the example above.
*/